
          import { mount } from "svelte";
          import Component from "/Users/nozzlegear/Repos/elleb-photos-ghost/src/js/pages/products-page.svelte";

          // Auto-instantiate on load
          // Use requestAnimationFrame to ensure Svelte's reactive context is properly established
          // This prevents the effect_orphan error that occurs when $effect runs outside component init
          if (typeof document !== 'undefined') {
            const doMount = () => {
              const targetTag = 'products-page';
              const target = document.querySelector(targetTag);

              if (target) {
                // Parse props from data-props attribute if present
                let props = {};
                const propsAttr = target.getAttribute('data-props');
                if (propsAttr) {
                  try {
                    props = JSON.parse(propsAttr);
                  } catch (e) {
                    console.error('[Ghost Svelte] Failed to parse data-props:', e);
                  }
                }

                mount(Component, { target, props });
              } else {
                console.warn('[Ghost Svelte] Target element <products-page> not found');
              }
            };

            // Schedule mount after current execution context to ensure proper Svelte initialization
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', doMount);
            } else {
              // Use requestAnimationFrame to defer to next frame, ensuring proper reactive context
              requestAnimationFrame(doMount);
            }
          }
        